// extracted by mini-css-extract-plugin
var _1 = "MentionsTab-module__checkboxes--YyNyP";
export { _1 as "checkboxes" }
